module.exports = __webpack_public_path__ + "files/8bb34121d42832c176fb9c78c148e6dd.png";